import { Door, DoorBatteryWarningLevel, Query } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';
import { removeFields } from 'mocks/graphqlMocks/removeFields';

export function mockedGetDoorsWithOfficeModeForTenantData(
  getDoorsForTenant: Array<Door>
): Pick<Query, 'getDoorsForTenant'> {
  return {
    getDoorsForTenant
  };
}

const fieldsToRemoveFromDoor: (keyof Door)[] = ['locations', 'locationIds', 'taReaderId', 'supportsOssCards'];

export const mockedGetDoorsWithOfficeDaysForTenantDataUnitTests = mockedGetDoorsWithOfficeModeForTenantData([
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId0',
      batteryWarningLevel: DoorBatteryWarningLevel.BatteryDefault,
      hardwareIdentifier: '66',
      name: 'door 0'
    }),
    fieldsToRemoveFromDoor
  ),
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId1',
      batteryWarningLevel: DoorBatteryWarningLevel.BatteryDefault,
      hardwareIdentifier: '66',
      name: 'door 1'
    }),
    fieldsToRemoveFromDoor
  ),
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId1',
      batteryWarningLevel: DoorBatteryWarningLevel.BatteryDefault,
      hardwareIdentifier: '66',
      name: 'door 1'
    }),
    fieldsToRemoveFromDoor
  )
]);

export const mockedGetDoorsWithOfficeDaysForTenantDataAdmin = mockedGetDoorsWithOfficeModeForTenantData(mockDoors);
